import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  CustomInput,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
} from '../../../../../../helpers/AxiosAPI';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import {
  gAPI_Property_List_By_Group,
  gAPI_Group_By_Id,
  gAPI_Users_By_Id,
} from '../../../../../../constants/APIs';
import roleListData from '../../../../../../data/rolelist.json';

export default function InviteUsersForm({
  formLabel,
  visible,
  toggle,
  id,
  submit,
}) {
  const [propertyList, setPropertyList] = useState([]);
  const [roleList, setRolesList] = useState([]);
  const [usersData, setUsersData] = useState({
    groupId: getGroupID(),
    groupName: '',
    email: '',
    properties: ['-1'],
    roles: ['Admin'],
    creator: 'dashboard',
    firstName: '',
    lastName: '',
    isBMB: true,
    isaiva: false,
    phoneNumber: '',
  });

  useEffect(() => {
    setRolesList(
      roleListData.data.map((p) => ({
        id: p.id,
        name: p.name,
        checked: false,
      }))
    );
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    }).then((res) => {
      const userproperties = res.data.properties;
      const isSuperAdmin =
        res.data?.isSuperAdmin && res.data.isSuperAdmin === true ? true : false;
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          const finalResult = [];
          if (userproperties.length > 0 && userproperties[0] === '-1') {
            res.data.forEach((p) => {
              finalResult.push({
                id: p.id,
                name: p.name,
                checked: false,
              });
            });
          } else if (isSuperAdmin) {
            res.data.forEach((p) => {
              finalResult.push({
                id: p.id,
                name: p.name,
                checked: false,
              });
            });
          } else {
            res.data.forEach((p) => {
              userproperties.forEach((r) => {
                if (p.id === r) {
                  finalResult.push({
                    id: p.id,
                    name: p.name,
                    checked: false,
                  });
                }
              });
            });
          }
          setPropertyList(finalResult);
        })
        .catch((err) => console.error(err));
    });
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Group_By_Id}/${getGroupID()}`,
    })
      .then((res) => {
        setUsersData({
          ...usersData,
          groupId: getGroupID(),
          groupName: res.data.name,
        });
      })
      .catch((err) => console.error(err));
  }, []);

  const handleChange = (e) => {
    setUsersData({
      ...usersData,
      [e.target.name]: e.target.value,
    });
  };

  const handlePropertiesChange = (e) => {
    const values = propertyList.map((elem) => {
      if (elem.id === e.target.value) {
        if (elem.checked) {
          elem.checked = false;
        } else if (!elem.checked) {
          elem.checked = true;
        }
      }
      return {
        ...elem,
      };
    });
    setPropertyList(values);
  };
  const handleSelectAllProperties = (e) => {
    const checked = e.target.checked;

    const values = propertyList.map((elem) => ({
      ...elem,
      checked,
    }));

    setPropertyList(values);
  };

  const handleRoleChange = (e) => {
    const values = roleList.map((elem) => {
      if (elem.name === e.target.value) {
        if (elem.checked) {
          elem.checked = false;
        } else if (!elem.checked) {
          elem.checked = true;
        }
      }
      return {
        ...elem,
      };
    });
    setRolesList(values);
  };

  useEffect(() => {
    const appPropertiesArr = propertyList
      .filter((elem) => elem.checked === true)
      .map((elem) => elem.id);

    const appRolesArr = roleList
      .filter((elem) => elem.checked === true)
      .map((elem) => elem.id);

    setUsersData({
      ...usersData,
      properties: appPropertiesArr,
      roles: appRolesArr,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyList, roleList]);

  const handleSubmit = () => {
    submit(usersData);
  };


  const isAllPropertiesSelected =
    propertyList.length > 0 &&
    propertyList.every((elem) => elem.checked);

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <Row>
                <Colxx sm={4} className="mb-3">
                  <Label>First Name</Label>
                  <Input className='input_sty' type="text" onChange={handleChange} name="firstName" />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Last Name</Label>
                  <Input className='input_sty' type="text" onChange={handleChange} name="lastName" />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Email</Label>
                  <Input className='input_sty' type="text" onChange={handleChange} name="email" />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Phone Number</Label>
                  <Input className='input_sty'
                    type="text"
                    onChange={handleChange}
                    name="phoneNumber"
                  />
                </Colxx>
              </Row>
              <h4>Roles & Properties</h4>
              <Row>
                <Colxx sm={4}>
                  <FormGroup>
                    <Label>Roles</Label>

                    {roleList.map((elem, index) => (
                      <CustomInput
                        key={index}
                        type="checkbox"
                        value={elem.name}
                        id={elem.id}
                        onChange={handleRoleChange}
                        checked={elem.checked}
                      >
                        {elem.name}
                      </CustomInput>
                    ))}
                  </FormGroup>
                </Colxx>
                <Colxx sm={6}>
                  <FormGroup>
                    <Label>Properties</Label>
                    {/* Select All */}
                    <CustomInput
                      type="checkbox"
                      id="selectAllProperties"
                      label="Select All"
                      onChange={handleSelectAllProperties}
                      checked={isAllPropertiesSelected}
                    />

                    {propertyList.map((elem, index) => (
                      <CustomInput
                        key={index}
                        type="checkbox"
                        value={elem.id}
                        id={`property-${elem.id}`}
                        onChange={handlePropertiesChange}
                        checked={elem.checked}
                      >
                        {elem.name}
                      </CustomInput>
                    ))}
                  </FormGroup>
                </Colxx>
              </Row>
            </Colxx>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            <IntlMessages id="dashboards.save" />
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}

InviteUsersForm.propTypes = {
  // formLabel: PropTypes.string.isRequired,
  // visible: PropTypes.bool.isRequired,
  // toggle: PropTypes.func.isRequired,
  // updateRatePlansData: PropTypes.shape({
  //   name: PropTypes.array.isRequired,
  //   description: PropTypes.array.isRequired,
  //   conditions: PropTypes.array.isRequired,
  //   status: PropTypes.string.isRequired,
  // }),
  // applicableAddOnsWithIdAndName: PropTypes.array.isRequired,
  // includedAddOnsWithIdAndName: PropTypes.array.isRequired,
  // applicablePromosWithIdAndName: PropTypes.array.isRequired,
};
